import Alpine from './alpine'

/**
 * The field builder behind a metaobject definition.
 *
 * Keeps a blank row at the end so adding the next field is not a click on "add"
 * first. The server drops the blanks, so an untouched row never comes back as a
 * validation error the merchant did not make.
 */
Alpine.data('fieldBuilder', (initial = []) => ({
    fields: [],

    init() {
        this.fields = (initial ?? []).map((field) => ({
            key: field.key ?? '',
            name: field.name ?? '',
            type: field.type ?? 'single_line_text_field',
            required: Boolean(field.required),
            help: field.help ?? '',
        }))

        this.ensureBlank()
    },

    add() {
        this.fields.push({ key: '', name: '', type: 'single_line_text_field', required: false, help: '' })
    },

    remove(index) {
        this.fields.splice(index, 1)
        this.ensureBlank()
    },

    ensureBlank() {
        const last = this.fields[this.fields.length - 1]

        if (! last || last.name !== '') {
            this.add()
        }
    },

    /** Fields that can name an entry: anything already given a name. */
    get named() {
        return this.fields.filter((field) => field.name !== '')
    },

    /*
     * The key a field will end up with. Shown rather than hidden, because a theme
     * addresses fields by key and a merchant needs to know what to type.
     */
    keyFor(field) {
        if (field.key) {
            return field.key
        }

        return field.name
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '')
    },
}))
